
import { EmailOutlined, PhoneOutlined, Facebook, Twitter, Instagram } from "@mui/icons-material";
import logo from "./logo.png";
import featureIcon1 from "./icon1.png";
import featureIcon2 from "./icon2.png";
import featureIcon3 from "./icon3.png";
import featureIcon4 from "./icon4.png";

// src/Util/homeData.js
import bannerImage from "../Assets/bannerimage.jpg";
import aboutImage from "../Assets/aboutImage.jpg";

export const navItems = [
  { label: "Home", id: "home" },
  { label: "About", id: "about" },
  { label: "Packages", id: "packages" },
  { label: "Features", id: "features" },
  { label: "Contact", id: "contact" },
];

export const bannerData = {
  image: bannerImage,
  headingTop: "DELIVERY UNLIMITED",
  headingMain: "FAST & SAFE TRANSPORT",
  subText:
    "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud.",
};

export const aboutData = {
  image: aboutImage,
  heading: "ABOUT EAGLE",
  subText: `Lorem ipsum dolor sit amet, consectetur adipiscing elit, 
  sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.

  Ut enim ad minim veniam, quis nostrud exercitation ullamco. 
  Lorem ipsum dolor sit amet, consectetur adipiscing elit, 
  sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.`,
};

export const packageData = [
    {
      title: "STARTER PACKAGE",
      price: 99,
      features: ["Single Truck", "Additional Truck Available", "Insurance", "1000 Km"],
    },
    {
      title: "PRO PACKAGE",
      price: 149,
      features: ["Double Truck", "Additional Truck Available", "Insurance", "1500 Km"],
    },
    {
      title: "BUSINESS PACKAGE",
      price: 199,
      features: ["Double Truck", "Additional Truck Available", "Insurance", "Unlimited"],
    },
  ];

  export const cargoDetailsData = {
  heading: "WE ARE THE BEST CARGO",
  description:
    "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit tellus, luctus nec ullamcorper mattis, pulvinar dapibus leo.",

  progress: [
    { label: "PROFIT GROWTH PER YEAR", value: 75 },
    { label: "SATISFIED CLIENTS", value: 85 },
    { label: "TRANSPORTS DONE", value: 95 },
  ],
};
  export const features = [
    { icon: featureIcon1, title: "FEATURE AND SKILLS" },
    { icon: featureIcon2, title: "SATISFIED CLIENT" },
    { icon: featureIcon3, title: "ON TIME" },
    { icon: featureIcon4, title: "FAST" },
  ];
export const addressList = [
    {
      title: "ADDRESS",
      value: "29 Avenue St. Los Angeles, USA",
    },
    {
      title: "PHONE",
      value: "+123 456 789",
    },
    {
      title: "EMAIL",
      value: "contact@connection.com",
    },
    {
      title: "SOCIAL",
      icons: true, // flag for social icons
    },
  ];

  export const mediaData = [
  { Icon: Facebook, link: "https://www.facebook.com" },
  { Icon: Twitter, link: "https://www.twitter.com" },
  { Icon: Instagram, link: "https://www.instagram.com" }
];

export const companyInfo = {
  name: "Your Company Name",
  logo:logo,
  description:
  "We are a reliable logistics and supply chain solutions provider, specializing in fast and secure transportation, warehousing, and last-mile delivery for businesses and individuals.",
  address: "198 West 21th Street",
  phone: "+123 456 78900",
  email: "example@gmail.com",
};